import { render, staticRenderFns } from "./Stage.vue?vue&type=template&id=61bc7c86"
import script from "./Stage.vue?vue&type=script&lang=js"
export * from "./Stage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports